"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPageNodeToDocument = exports.mapEventNodeToDocument = exports.mapPostNodeToDocument = exports.seoSliceMapper = exports.getSeoSlice = exports.splitKeywords = exports.extractSlicesText = exports.extractNodes = void 0;
// TODO: no type definition?
const extractTextFromRawSlices = require('@kogk/gatsby-theme-prismic/lib/extract-text-from-raw-slices');
const extractNodes = (data, predicate) => {
    if (Array.isArray(data)) {
        return data.flatMap(item => (0, exports.extractNodes)(item, predicate));
    }
    if (data && typeof data === 'object' && predicate(data)) {
        return [data];
    }
    if (data && typeof data === 'object') {
        return (0, exports.extractNodes)(Object.values(data), predicate);
    }
    return [];
};
exports.extractNodes = extractNodes;
const extractRichText = (data) => {
    return data.map(node => node.text).join('\n');
};
const extractSlicesText = (data) => {
    return extractTextFromRawSlices(data.filter(node => node.slice_type !== 'embed')).join('\n');
};
exports.extractSlicesText = extractSlicesText;
const splitKeywords = (kw) => {
    return (kw ?? '')
        .split(/[,;]/g)
        .map(s => s.trim())
        .filter(Boolean);
};
exports.splitKeywords = splitKeywords;
const getSeoSlice = (node) => (0, exports.extractNodes)(node.dataRaw, x => x.slice_type === 'seo')[0];
exports.getSeoSlice = getSeoSlice;
const seoSliceMapper = (seo) => {
    return {
        seoTitle: seo.primary.override_title,
        seoDescription: seo.primary.override_description,
        seoKeywords: (0, exports.splitKeywords)(seo.primary?.override_keywords ?? '')
    };
};
exports.seoSliceMapper = seoSliceMapper;
const mapPostNodeToDocument = (node) => {
    const seo = (0, exports.getSeoSlice)(node);
    if (!seo)
        return null;
    const { url, lang, dataRaw } = node;
    return {
        id: node.id,
        lang: lang.split('-')[0],
        path: typeof url === 'string' ? url : '',
        title: extractRichText(dataRaw.title),
        subtitle: extractRichText(dataRaw.subtitle),
        body: (0, exports.extractSlicesText)(dataRaw.body),
        ...(0, exports.seoSliceMapper)(seo)
    };
};
exports.mapPostNodeToDocument = mapPostNodeToDocument;
const mapEventNodeToDocument = (node) => {
    const seo = (0, exports.extractNodes)(node.dataRaw, x => x.slice_type === 'seo')[0];
    if (!seo)
        return null;
    const { url, lang, dataRaw } = node;
    const date = new Date(dataRaw.to || dataRaw.from);
    return {
        id: node.id,
        lang: lang.split('-')[0],
        path: typeof url === 'string' ? url : '',
        title: extractRichText(dataRaw.title),
        subtitle: extractRichText(dataRaw.subtitle),
        body: [
            extractRichText(dataRaw.subtitle),
            (0, exports.extractSlicesText)(dataRaw.body)
        ].join('\n'),
        seoTitle: seo.primary?.override_title,
        seoDescription: seo.primary?.override_description,
        seoKeywords: (0, exports.splitKeywords)(seo.primary?.override_keywords ?? ''),
        expires: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3).getTime()
    };
};
exports.mapEventNodeToDocument = mapEventNodeToDocument;
const mapPageNodeToDocument = (node) => {
    const seo = (0, exports.getSeoSlice)(node);
    if (!seo)
        return null;
    const { url, lang, dataRaw, tags } = node;
    // we dont' want the frontpage
    // to be included in the search results
    if (tags.includes('DEFAULT_FRONTPAGE'))
        return null;
    return {
        id: node.id,
        lang: lang.split('-')[0],
        path: typeof url === 'string' ? url : '',
        title: dataRaw.page_title
            ? extractRichText(dataRaw.page_title)
            : extractRichText(dataRaw.title),
        body: (0, exports.extractSlicesText)(dataRaw.body),
        ...(0, exports.seoSliceMapper)(seo)
    };
};
exports.mapPageNodeToDocument = mapPageNodeToDocument;
//# sourceMappingURL=prismic.js.map